import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import config from '@/config';
import { StaticModal, useModal } from '@/modules/modals';
import { Button, ButtonType, Heading, Icon } from '@/modules/ui';

import { useApiKeysList } from '../../hooks';
import { ApiKeysTable } from '../ApiKeysTable';
import { CreateApiKeyModal } from '../CreateApiKeyModal';
import * as felaRules from './ApiKeysPage.rules';

export const ApiKeysPage = () => {
    const { css } = useFela();
    const { formatMessage } = useIntl();
    const query = useApiKeysList();
    const { updateModal } = useModal(StaticModal.CREATE_API_KEY);

    const navigate = useNavigate();
    // A `default` location key marks the first entry of the history stack — there is nothing to go back to.
    const { key: locationKey } = useLocation();

    return (
        <div className={css(felaRules.container)}>
            <div className={css(felaRules.header)}>
                <Heading elementType='h1' variant='h2' color='black' customStyle={felaRules.title}>
                    <button
                        type='button'
                        className={css(felaRules.backButton)}
                        aria-label={formatMessage({ id: 'back' })}
                        onClick={() => (locationKey === 'default' ? navigate(config.routes.secrets) : navigate(-1))}
                    >
                        <Icon type='dropdown' />
                    </button>
                    <FormattedMessage id='api-keys.title' />
                </Heading>
                <Button type={ButtonType.PRIMARY} onClick={() => updateModal(true)} customStyle={felaRules.createButton}>
                    <FormattedMessage id='api-keys.actions.create' />
                </Button>
            </div>
            <ApiKeysTable query={query} />
            <CreateApiKeyModal />
        </div>
    );
};
